const TOAST_DURATION = 5000;
const TOAST_EXIT_DURATION = 200;
export const normalizeToast = (input) => {
    if (typeof input === "string") {
        return { content: input || "Unknown error occurred" };
    }
    return input;
};
export const createToastTimer = (setTimer, clearTimer) => {
    let activeTimers = [];
    let generation = 0;
    const clear = () => {
        generation += 1;
        for (const timer of activeTimers) {
            clearTimer(timer);
        }
        activeTimers = [];
    };
    const restart = (onExit, onDismiss) => {
        clear();
        const currentGeneration = generation;
        activeTimers = [
            setTimer(() => {
                if (currentGeneration !== generation)
                    return;
                onExit();
            }, TOAST_DURATION),
            setTimer(() => {
                if (currentGeneration !== generation)
                    return;
                activeTimers = [];
                onDismiss();
            }, TOAST_DURATION + TOAST_EXIT_DURATION),
        ];
    };
    return { restart, clear };
};
export const createToastApi = (show, destroy) => ({
    open: (input) => show(normalizeToast(input)),
    error: (content) => show({ type: "error", content }),
    success: (content) => show({ type: "success", content }),
    warning: (content) => show({ type: "warning", content }),
    destroy,
});
//# sourceMappingURL=model.js.map